import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  label?: string;
}

const sizeMap = {
  sm: 'h-6 w-6 border-2',
  md: 'h-10 w-10 border-[3px]',
  lg: 'h-12 w-12 border-[3px]',
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'lg',
  fullScreen = true,
  label = 'Loading...',
}) => {
  const spinner = (
    <div className="flex flex-col items-center justify-center gap-3">
      <div
        className={`animate-spin rounded-full border-primary/30 border-t-primary ${sizeMap[size]}`}
        role="status"
        aria-label={label}
      />
      {size !== 'sm' && (
        <p className="text-sm text-muted-foreground animate-pulse">{label}</p>
      )}
      <span className="sr-only">{label}</span>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;
